import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import moment from "moment";

import {View} from "@khanacademy/wonder-blocks-core";
import {Checkbox} from "@khanacademy/wonder-blocks-form";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {
    DateRangeDropdown,
    type DateRangeSelection,
} from "@khan/component-date-range-dropdown";

import {ChatRetentionNotice} from "../chat-retention-notice.tsx";

interface Props {
    /**
     * The current date range selection
     */
    dateRangeSelection: DateRangeSelection;
    /**
     * Function to update the date range selection
     */
    setDateRangeSelection: React.Dispatch<
        React.SetStateAction<DateRangeSelection>
    >;
    /**
     * Whether to only show flagged threads
     */
    flaggedThreadsOnly: boolean;
    /**
     * Function to update the flagged threads filter
     */
    setFlaggedThreadsOnly: React.Dispatch<React.SetStateAction<boolean>>;
    /**
     * Whether the user is a learner
     */
    userIsLearner: boolean;
}

/**
 * Renders the filters for table view.
 */
const GuideTranscriptsFilters = ({
    dateRangeSelection,
    setDateRangeSelection,
    flaggedThreadsOnly,
    setFlaggedThreadsOnly,
    userIsLearner,
}: Props): React.ReactNode => (
    <View style={styles.headingContainer}>
        <View style={styles.filtersContainer}>
            <DateRangeDropdown
                onChange={setDateRangeSelection}
                dateRangeSelection={dateRangeSelection}
                style={styles.dateRangeDropdown}
                maxDate={moment()}
            />
            {!userIsLearner && (
                <Checkbox
                    label={t`Only show flagged chats`}
                    checked={flaggedThreadsOnly}
                    onChange={setFlaggedThreadsOnly}
                />
            )}
        </View>
        <ChatRetentionNotice />
    </View>
);

const styles = StyleSheet.create({
    headingContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    filtersContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: spacing.large_24,
    },
    dateRangeDropdown: {
        width: "28.8rem",
    },
});

export {GuideTranscriptsFilters};
